import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-applications-home',
    templateUrl: './applications-home.component.html',
    styleUrls: ['./applications-home.component.scss'],
    standalone: false
})
export class ApplicationsHomeComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
